import React from 'react';
import classes from "./styles/AboutCoach.module.css";
import firstImg from "../../assets/about/img1.jpg";
import img1 from "../../assets/about/img2.jpg";
import img2 from "../../assets/about/img3.jpg";
import img3 from "../../assets/about/img4.jpg";

import cer1 from "../../assets/about/cer1.jpeg";
import cer2 from "../../assets/about/cer2.jpeg";
import cer3 from "../../assets/about/cer3.jpeg";

import checkIcon from "../../assets/thirdSec/check.png";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const AboutCoach = () => {
  const navigate = useNavigate();

  const scrollToJoinBtn = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById("JoinNowBtn");
      if (element) {
        const offset = -80;
        const topPos = element.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top: topPos, behavior: 'smooth' });
      }
    }, 500); // delay long enough for page load
  };

  document.title = "Know Your Coach - Meet Coach Susmita Roy"

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Know Your Coach - Meet Coach Susmita Roy</title>
        <meta name="description" content="Discover the inspiring journey of Coach Susmita—from global public health expert to certified fitness and nutrition coach. Offering personalized, sustainable health solutions for real people and busy lives." />
      </Helmet>

      <div className={classes.headlineCon} onClick={scrollToJoinBtn}>
        <p className={classes.scrollText}>Online Fitness & Nutrition Coaching – New Batches Going Live This Week! Enroll Now!</p>
      </div>
      <h1>Susmita’s Journey: From Public Health to Personal Health <br />(Holistic Fitness & Nutrition Coach)</h1>


      <h3>From Public Health to Personal Wellness: Susmita’s Powerful Journey</h3>
      <section className={`${classes.section}`}>
        <div className={classes.contentCon}>
            <p>Susmita Roy’s journey into fitness coaching is anything but ordinary. With over <b>15 years of experience in public health</b>, she brings a rare depth of understanding to wellness. Susmita holds best students award in two prestigious educational institutions <b>St. Xavier Mumbai</b> and <b>Tata Institute of Social Sciences (TISS) Mumbai.</b></p>
            <br/>
            <p>Her career includes impactful work with UNICEF, WHO, and the Bill & Melinda Gates Foundation (BMGF), leading initiatives like:</p>
            <br />
            <div className={classes.highlightDiv}>
              <p><img src={checkIcon} alt='check'/>National AIDS Control Program (NACO), MoHFW</p>
              <p><img src={checkIcon} alt='check'/>Mission Indradhanush (India’s immunization mission)</p>
              <p><img src={checkIcon} alt='check'/>POCT health technology development in Bangladesh</p>
            </div>
        </div>
        <div className={classes.imageCon}>
          <img src={firstImg} alt="Susmita" className={classes.img1}/>
        </div>
      </section>





      <h3>Turning Personal Health Struggles into a Purpose-Driven Career</h3>
      <section className={`${classes.section} ${classes.sectionMobile}`}>
        <div className={classes.imageCon}>
          <img src={img1} alt="Susmita" />
        </div>
        <div className={classes.contentCon}>
            <p>While Susmita’s professional life thrived, she faced a silent personal battle. Years of <b>sinus issues, weight gain, joint pain,</b> and eventually <b>uterine fibroids</b> forced her to pause and reassess her own health. Once a competitive athlete, she found it hard to keep up with even basic daily routines.</p>
            <br/>
            <p>This became her turning point.</p>
            <br />
            <p>She decided to take charge of her health and got certified as a Fitness Coach and Nutritionist, combining her public health expertise with a personal transformation story.</p>
        </div>
      </section>

      <div className={classes.certificateSec}>
      <h3>Certificates of Fitness Trainer and Nutritionist</h3>
      <section className={classes.certificateCon}>
        <div>
          <img src={cer1} alt="certificate" />
        </div>
        <div>
          <img src={cer2} alt="certificate" />
        </div>
        <div>
          <img src={cer3} alt="certificate" />
        </div>
      </section>
      </div>


      <h3>Her Unique Fitness Philosophy: Real Life, Real People, Real Results</h3>
      <section className={classes.section}>
        <div className={classes.contentCon}>
            <p>Susmita believes in <b>simple, sustainable fitness solutions</b>—not crash diets or extreme workouts. Over the last six years, she’s helped <b>hundreds of individuals</b> across all age groups—from working professionals to senior citizens—through:</p>
            <br/>
            <div className={classes.highlightDiv}>
              <p><img src={checkIcon} alt='check'/>Personalized workout plans</p>
              <p><img src={checkIcon} alt='check'/>Home-based, minimal-equipment training</p>
              <p><img src={checkIcon} alt='check'/>Nutrition guidance that fits real life</p>
            </div>
            <br />
            <p>Her approach focuses on <b>functionality over perfection</b>—helping people <b>move better, feel stronger, and live healthier</b> without gym dependency.</p>
        </div>
        <div className={classes.imageCon}>
          <img src={img2} alt="Susmita" />
        </div>
      </section>


      <h3>Her Mission: Making Health Simple, Sustainable & Accessible</h3>
      <section className={`${classes.section} ${classes.sectionMobile}`}>
        <div className={classes.imageCon}>
          <img src={img3} alt="Susmita" />
        </div>
        <div className={classes.contentCon}>
            <p>Susmita’s goal is to <b>make health and fitness approachable for everyone</b>—especially for those who feel like they “just don’t have the time.” Her coaching is designed around:</p>
            <br/>
            <div className={classes.highlightDiv}>
              <p><img src={checkIcon} alt='check'/>Consistency over intensity</p>
              <p><img src={checkIcon} alt='check'/>Prevention over cure</p>
              <p><img src={checkIcon} alt='check'/>Practical nutrition and movement tailored for busy lifestyles</p>
            </div>
            <br />
            <p>She empowers her clients to <b>take small, powerful steps</b> toward better health—whether they’re recovering postpartum, navigating hormonal shifts after 30, or simply trying to feel more energetic and confident.</p>
        </div>
      </section>

      <h3>Why Get Fit With Susmita?</h3>
      <section className={classes.whyChose}>
        <div className={classes.whyChoseDiv}>
          <div><img src='https://cdn-icons-png.flaticon.com/128/10605/10605926.png' alt='flower'/></div>
          <p>15+ years of public health leadership</p>
        </div>
        <div className={classes.whyChoseDiv}>
          <div><img src='https://cdn-icons-png.flaticon.com/128/6036/6036814.png' alt='flower'/></div>
          <p>Certified Fitness & Nutrition Coach</p>
        </div>
        <div className={classes.whyChoseDiv}>
          <div><img src='https://cdn-icons-png.flaticon.com/128/860/860511.png' alt='flower'/></div>
          <p>Individual Focused Approach on fitness fundamentals</p>
        </div>
        <div className={classes.whyChoseDiv}>
          <div><img src='https://cdn-icons-png.flaticon.com/128/2982/2982182.png' alt='flower'/></div>
          <p>Live Fitness and Customised Nutrition plans</p>
        </div>
        <div className={classes.whyChoseDiv}>
          <div><img src='https://cdn-icons-png.flaticon.com/128/12646/12646044.png' alt='flower'/></div>
          <p>Expertise in women’s health and postpartum fitness </p>
        </div>
      </section>

    </div>
  )
}

export default AboutCoach;
